<template>
  <div id="contenedor-listado-desktop">
    <v-data-table
      :headers="headers"
      :items="getReportesFisicos"
      :items-per-page="20">
      <template v-slot:[`item.fecha`]="{ item }">
        <!-- {{ new Date(item.fecha).toLocaleDateString() }} -->
        {{ $moment(item.fecha).format('DD/MM/YYYY') }}
      </template>
      <template v-slot:[`item.existeProblema`]="{ item }">
        <v-icon
          v-if="item.existeProblema"
          class="orange--text">
          warning
        </v-icon>
      </template>
      <template v-slot:[`item.avanceFisico`]="{ item }">
        <b>{{ item.avanceFisico }}%</b>
      </template>
      <template v-slot:[`item.calidad`]="{ item }">
        <v-chip small :color="getColorCalidad(item.calidad)"></v-chip>
      </template>
      <template v-slot:[`item.partidas`]="{ item }">
        <v-chip small color="indigo lighten-4">
          <b>{{ item.partidas.length }}</b>
        </v-chip>
      </template>
      <template v-slot:[`item.comentarios`]="{ item }">
        <small>
          <cortar-texto
          :texto="item.comentarios">
          </cortar-texto>
        </small>
      </template>
      <template v-slot:[`item.descripcionProblema`]="{ item }">
        <small>
          <cortar-texto
          :texto="item.descripcionProblema ? item.descripcionProblema : ''">
          </cortar-texto>
        </small>
      </template>
      <template v-slot:[`item.fechaHoraRevisado`]="{ item }">
        <SwitchRevisado v-if="!setEsContratista" :reporteFisico="item" />
        <template v-else-if="item.fechaHoraRevisado">
          <v-row justify="center">
            <v-icon  color="success">
              mdi-check-circle-outline
            </v-icon>
          </v-row>
        </template>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="verResporte(item)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Ver Reporte</span>
        </v-tooltip>
        <!-- BOTONES PARA EDITAR Y ELIMINAR -->
        <v-tooltip
        v-if="item.numero == getReportesFisicos.length
        && mixValidaScopesActions(2)
        && revisadoAndContratista(item)"
        top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click="editarReporteFisico(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top v-if="item.numero == getReportesFisicos.length && mixValidaScopesActions(3)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="eliminarReporteFisico(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Eliminar</span>
      </v-tooltip>
        <!-- <opciones :id="item.id"></opciones> -->
      </template>
    </v-data-table>
    <v-dialog
      v-model="mostrarVentanaReporteFisico"
      fullscreen
      transition="dialog-bottom-transition">
      <detalles-reporte
        :reporteFisico="reporteSeleccionado"
        v-on:cerrar="mostrarVentanaReporteFisico = false">
      </detalles-reporte>
    </v-dialog>
    <!-- <v-dialog
      v-model="mostrarVentanaEditarReporte"
      fullscreen>
      <editar-reporte
        v-if="mostrarVentanaEditarReporte"
        :ultimoReporteFisico="ultimoReporteFisico"
        v-on:cerrar="mostrarVentanaEditarReporte = false">
      </editar-reporte>
    </v-dialog> -->
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import DetallesReporte from '@/components/administracion/ejecucion/reportes/DetallesReporte.vue';
import CortarTexto from '@/components/CortarTextos.vue';
import SwitchRevisado from '@/components/administracion/ejecucion/reportes/FechaHoraRevisadoCheck.vue';
// import EditarReporte from '@/components/administracion/ejecucion/reportes/editar/Editar.vue';
// import Opciones from './Opciones.vue';

export default {
  name: 'ListadoDesktop',
  components: {
    // Opciones,
    DetallesReporte,
    CortarTexto,
    SwitchRevisado,
    // EditarReporte,
  },
  props: {
    reportesFisicos: Array,
  },
  data() {
    return {
      mostrarVentanaEditarReporte: false,
      ultimoReporteFisico: {},
      headers: [
        {
          text: 'Número',
          align: 'center',
          sortable: false,
          value: 'numero',
          width: '1%',
        },
        {
          text: 'Fecha',
          align: 'center',
          sortable: false,
          value: 'fecha',
          width: '10%',
        },
        {
          text: 'Existe Problema?',
          sortable: false,
          value: 'existeProblema',
          align: 'center',
          width: '1%',
        },
        {
          text: 'Avance',
          sortable: false,
          value: 'avanceFisico',
          width: '1%',
        },
        {
          text: 'Calidad',
          align: 'center',
          sortable: false,
          value: 'calidad',
          width: '1%',
        },
        {
          text: 'Partidas',
          sortable: false,
          align: 'center',
          value: 'partidas',
          width: '1%',
        },
        {
          text: 'Comentarios',
          sortable: false,
          value: 'comentarios',
        },
        {
          text: 'Problema',
          sortable: false,
          value: 'descripcionProblema',
        },
        // { text: 'F. Termino', value: 'fechaTermino' },
        {
          text: 'Revisado',
          sortable: false,
          width: '1%',
          value: 'fechaHoraRevisado',
        },
        {
          text: '',
          value: 'acciones',
          sortable: false,
          align: 'end',
          width: '150',
        },
      ],
      mostrarVentanaReporteFisico: false,
      reporteSeleccionado: {},
    };
  },
  methods: {
    revisadoAndContratista(reporte) {
      if (this.setEsContratista && reporte.fechaHoraRevisado) {
        return false;
      }
      return true;
    },
    verResporte(item) {
      // this.reporteSeleccionado = item;
      eventBus.$emit('ver-reporte-fisico', item);
      // this.mostrarVentanaReporteFisico = true;
    },
    // editarEsteReporte(item) {
    //   this.ultimoReporteFisico = item;
    //   this.mostrarVentanaEditarReporte = true;
    // },
    editarReporteFisico(reporte) {
      eventBus.$emit('editar-reporte-fisico', reporte);
    },
    eliminarReporteFisico(reporte) {
      eventBus.$emit('eliminar-reporte-fisico', reporte);
    },
    getColorCalidad(calidad) {
      switch (calidad) {
        case 1:
          return 'green';
        case 2:
          return 'amber';
        default:
          return 'red';
      }
    },
  },
  computed: {
    getReportesFisicos() {
      if (!this.reportesFisicos) return [];
      return this.reportesFisicos;
    },
    setEsContratista() {
      const { roles } = this.$auth.user;
      return roles.includes('CONTRATISTA:SUPERVISION');
    },
  },
};
</script>

<style lang="scss">

</style>
